import Vue from 'vue';
import * as types from '../mutation-types';
import ConversationAPI from '../../api/conversations';
import LabelsAPI from '../../api/labels';

const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isUpdating: false,
    isError: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getConversationLabels: $state => id => {
    return $state.records[Number(id)] || [];
  },
};

export const actions = {
  get: async ({ commit }, conversationId) => {
    commit(types.default.SET_CONVERSATION_LABELS_UI_FLAG, {
      isFetching: true,
    });
    try {
      const response = await ConversationAPI.getLabels(conversationId);
      commit(types.default.SET_CONVERSATION_LABELS, {
        id: conversationId,
        data: response.data.payload,
      });
      commit(types.default.SET_CONVERSATION_LABELS_UI_FLAG, {
        isFetching: false,
      });
    } catch (error) {
      commit(types.default.SET_CONVERSATION_LABELS_UI_FLAG, {
        isFetching: false,
      });
    }
  },
  update: async ({ commit }, { conversationId, labels }) => {
    commit(types.default.SET_CONVERSATION_LABELS_UI_FLAG, {
      isUpdating: true,
    });
    try {
      const response = await ConversationAPI.updateLabels(
        conversationId,
        labels
      );
      commit(types.default.SET_CONVERSATION_LABELS, {
        id: conversationId,
        data: response.data.payload,
      });
      commit(types.default.SET_CONVERSATION_LABELS_UI_FLAG, {
        isUpdating: false,
        isError: false,
      });
    } catch (error) {
      commit(types.default.SET_CONVERSATION_LABELS_UI_FLAG, {
        isUpdating: false,
        isError: true,
      });
    }
  },
  addAppointmentLabels: async (
    { commit, dispatch },
    { conversationId, branchName, serviceName }
  ) => {
    try {
      console.log(
        'Starting appointment label process for conversation:',
        conversationId
      );

      console.log(
        'Creating branch and service labels:',
        branchName,
        serviceName
      );

      // Create labels in the system first if they don't already exist
      try {
        // Call the helper function directly since it's in the same module
        await dispatch(
          'createLabelIfNotExists',
          branchName.replace(/\s+/g, '').toLowerCase()
        );
        await dispatch(
          'createLabelIfNotExists',
          serviceName.replace(/\s+/g, '').toLowerCase()
        );
      } catch (labelCreationError) {
        console.error('Error creating labels:', labelCreationError);
        // Continue with the process even if label creation fails
      }

      // Now get the current labels on the conversation
      const response = await ConversationAPI.getLabels(conversationId);
      const currentLabels = response.data.payload || [];
      console.log('Current labels on conversation:', currentLabels);

      // Filter out any existing branch: or service: labels
      const filteredLabels = currentLabels.filter(
        label =>
          label !== branchName.replace(/\s+/g, '').toLowerCase() &&
          label !== serviceName.replace(/\s+/g, '').toLowerCase()
      );

      // Add the new branch and service labels
      const updatedLabels = [
        ...filteredLabels,
        branchName.replace(/\s+/g, '').toLowerCase(),
        serviceName.replace(/\s+/g, '').toLowerCase(),
      ];
      console.log('Updated labels to apply:', updatedLabels);

      // Update labels using existing action
      await dispatch('update', {
        conversationId,
        labels: updatedLabels,
      });

      console.log(
        'Successfully applied labels to conversation:',
        conversationId
      );
      return true;
    } catch (error) {
      console.error('Failed to add appointment labels:', error);
      return false;
    }
  },

  // Helper action to create a label if it doesn't exist
  createLabelIfNotExists: async ({}, labelTitle) => {
    try {
      // Get existing labels directly from the API
      const response = await LabelsAPI.get(); // true = include account scoped labels
      const existingLabels = response.data.payload || [];
      const labelExists = existingLabels.some(
        label => label.title === labelTitle
      );

      if (!labelExists) {
        console.log(`Label "${labelTitle}" doesn't exist, creating it...`);
        // Create the label directly using the API instead of going through the store
        await LabelsAPI.create({
          title: labelTitle,
          description: `Automatically created label for ${
            labelTitle.split(':')[0]
          }`,
          show_on_sidebar: true,
        });
        console.log(`Label "${labelTitle}" created successfully`);
      } else {
        console.log(`Label "${labelTitle}" already exists, skipping creation`);
      }
      return true;
    } catch (error) {
      console.error(`Error creating label "${labelTitle}":`, error);
      throw error;
    }
  },
  setBulkConversationLabels({ commit }, conversations) {
    commit(types.default.SET_BULK_CONVERSATION_LABELS, conversations);
  },
  setConversationLabel({ commit }, { id, data }) {
    commit(types.default.SET_CONVERSATION_LABELS, { id, data });
  },
};

export const mutations = {
  [types.default.SET_CONVERSATION_LABELS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_CONVERSATION_LABELS]: ($state, { id, data }) => {
    Vue.set($state.records, id, data);
  },
  [types.default.SET_BULK_CONVERSATION_LABELS]: ($state, conversations) => {
    conversations.forEach(conversation => {
      Vue.set($state.records, conversation.id, conversation.labels);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
